import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { CountriesLoadingDialog } from "./countries-loading-dialog/CountriesLoadingDialog";
import { CountryDeleteDialog } from "./country-delete-dialog/CountryDeleteDialog";
import { CountriesDeleteDialog } from "./countries-delete-dialog/CountriesDeleteDialog";
import { CountriesFetchDialog } from "./countries-fetch-dialog/CountriesFetchDialog";
import { CountriesUpdateStatusDialog } from "./countries-update-status-dialog/CountriesUpdateStatusDialog";
import { CountriesCard } from "./CountriesCard";
import { CountriesUIProvider } from "./CountriesUIContext";

function CountriesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CountriesDeleteDialog show={location.pathname === "/location/countries/deleteCountries"} onHide={() => navigate("/location/countries")} />;
}
function CountryDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <CountryDeleteDialog show id={id} onHide={() => navigate("/location/countries")} />;
}
function CountriesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CountriesFetchDialog show={location.pathname === "/location/countries/fetch"} onHide={() => navigate("/location/countries")} />;
}
function CountriesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CountriesUpdateStatusDialog show={location.pathname === "/location/countries/updateStatus"} onHide={() => navigate("/location/countries")} />;
}

export function CountriesPage() {
  const navigate = useNavigate();
  const countriesUIEvents = {
    newCountryButtonClick: () => navigate("/location/countries/new"),
    openEditCountryPage: (id) => navigate(`/location/countries/${id}/edit`),
    openDeleteCountryDialog: (id) => navigate(`/location/countries/${id}/delete`),
    openDeleteCountriesDialog: () => navigate("/location/countries/deleteCountries"),
    openFetchCountriesDialog: () => navigate("/location/countries/fetch"),
    openUpdateCountriesStatusDialog: () => navigate("/location/countries/updateStatus"),
  };

  return (
    <CountriesUIProvider countriesUIEvents={countriesUIEvents}>
      <CountriesLoadingDialog />
      <Routes>
        <Route path="deleteCountries" element={<CountriesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<CountryDeleteDialogRoute />} />
        <Route path="fetch" element={<CountriesFetchDialogRoute />} />
        <Route path="updateStatus" element={<CountriesUpdateStatusDialogRoute />} />
      </Routes>
      <CountriesCard />
    </CountriesUIProvider>
  );
}
